import React from "react";

type Props = {
  className?: string;
  children?: React.ReactNode;
};

const Center: React.FC<Props> = ({ children, className }) => {
  return (
    <div
      className={`d-flex align-items-center justify-content-center ${
        className ?? ""
      }`}
    >
      {children}
    </div>
  );
};

export default Center;
